// Global packages and components
import imageUrlBuilder from '@sanity/image-url'
import { sanity } from '~/sanity'
import { useRouteLoaderData } from '@remix-run/react'

// Types
import type { SanityReference } from '@sanity/client'
import type { RootDataProps, SanityRefWithAlt } from '~/types'

const useSanityImages = () => {
  // Global env values from root
  const { env } = useRouteLoaderData('root') as RootDataProps

  // Sanity client
  const client = sanity({
    dataset: env.ENVIRONMENT,
    projectId: env.SANITY_PROJECT,
  })

  // Sanity builder function
  const builder = imageUrlBuilder(client)

  // Fetch our actual image url
  const urlFor = (source: SanityReference | SanityRefWithAlt) => {
    return builder.image(source)
  }

  return {
    urlFor,
  }
}

export default useSanityImages
